<script>
	import DataFetcher from '~/components/DataFetcher.svelte';
	import AnswerForm from '~/components/AnswerForm.svelte';
	import Spinner from '~/components/Spinner.svelte';
	import Question from '~/components/Question.svelte';
    import { slide } from 'svelte/transition';
    import { db, isAdmin } from '~/firebase';
	
	let author = '';
	let question = '';

	let state = 'ready';
	let error = '';

	async function submit() {
		state = 'submitting';
		error = null;
		try {
			await db.ref('questions').add({
				timestamp: Date.now(),
				author,
				question,
				visible: false
			});
			state = 'done';
		}
		catch (e) {
			state = 'error';
			error = e.message || e;
		}
	}
</script>

<style lang="scss">
	.limit {
		text-align: right;
	}
</style>

<svelte:head>
	<title>Nan Dake - Ask</title>
</svelte:head>

<h2>Ask</h2>

<p>
	This is a place where you can ask me public questions (anonymously if preferred).
	When and if I answer your question it will appear here.
</p>

<p>
	For business enquiries please use the link at the bottom of the page.
</p>

{#if state == 'loading'}
    <Spinner/>
{:else if state == 'error'}
	<div transition:slide={{duration: 200}} class="error">
		<strong>Error: </strong>{error}
	</div>
{:else if state == 'done'}
	<div transition:slide={{duration: 200}} class="success">
		Thanks for your question. It will appear here once it has been answered.
	</div>
{:else if state == 'asking'}
	<form transition:slide={{duration: 200}} on:submit|preventDefault={submit}>
		<label>
			<div>Name (leave blank for anonymous)</div>
			<input bind:value={author} placeholder="Anonymous">
		</label>
		<label>
			<div>Question</div>
			<textarea bind:value={question} maxlength="1024" required></textarea>
			<div class="subtle limit">{question.length}/1024</div>
		</label>
		<div>
			<button>Submit question</button>
			<button type="button" on:click={() => state = 'ready'}>Cancel</button>
		</div>
	</form>
{:else if state == 'ready'}
	<div transition:slide={{duration: 200}}>
		<button type="button" on:click={() => state = 'asking'}>Ask question</button>
	</div>
{/if}

<h2>Answered</h2>

<DataFetcher collection="questions" let:item>
	<div class="subtle centered" slot="empty">
		No questions answered yet...
	</div>
	<Question question={item.question} timestamp={item.timestamp} author={item.author} answer={item.answer}/>
	{#if $isAdmin}
		<AnswerForm id={item.__meta__.id} answer={item.answer}/>
	{/if}
</DataFetcher>
